import styled from "styled-components";

export const WrapperCountryDropdown = styled.div`
  .dropdown-item:focus,
  .dropdown-item:hover {
    background-color: rgba(50, 0, 102, 0.8);
  }
`;
